import {LocalizationProvider} from "@mui/x-date-pickers";
import 'dayjs/locale/en';
import 'dayjs/locale/ru';
import {useSelector} from "react-redux";
import {userLangSelector} from "@/features/LangSwitcher/Slice/LangSlice";
import {enUS, ruRU} from "@mui/x-date-pickers/locales";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/en";
import "dayjs/locale/ru";

function AppLocalizationProvider({children}: { children: React.ReactNode }) {

    const userLang = useSelector(userLangSelector);
    const ruLocaleText = ruRU.components.MuiLocalizationProvider.defaultProps.localeText;
    const enLocaleText = enUS.components.MuiLocalizationProvider.defaultProps.localeText;
    const datepickerLocaleText = userLang === "ru" ? ruLocaleText : enLocaleText;
    const adapterLocale = userLang === "ru" ? "ru" : "en";

    return (
      <LocalizationProvider
        dateAdapter={AdapterDayjs}
        adapterLocale={adapterLocale}
        localeText={datepickerLocaleText}
      >
          {children}
      </LocalizationProvider>
    );
}

export default AppLocalizationProvider;
